import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
  SupplierBill, SupplierBillCreateDTO, SupplierBillResponse,
  BillEditDTO, SupplierBillEdit,
} from '../interfaces/procurement/supplierBill.interface';

export const SupplierBillService = {
  listByPurchaseOrder: async (purchaseOrderId: string, page = 0, size = 10): Promise<SupplierBillResponse> =>
    (await axios.get(`${ENDPOINTS.SUPPLIER_BILL.LIST_BY_PURCHASE_ORDER(purchaseOrderId)}?page=${page}&size=${size}`)).data,
  listBySupplier: async (supplierId: string, page = 0, size = 10): Promise<SupplierBillResponse> =>
    (await axios.get(`${ENDPOINTS.SUPPLIER_BILL.LIST_BY_SUPPLIER(supplierId)}?page=${page}&size=${size}`)).data,
  getById: async (id: string): Promise<SupplierBill> =>
    (await axios.get(ENDPOINTS.SUPPLIER_BILL.GET_BY_ID(id))).data,
  create: async (dto: SupplierBillCreateDTO): Promise<SupplierBill> =>
    (await axios.post(ENDPOINTS.SUPPLIER_BILL.CREATE, dto)).data,
  reverse: async (id: string): Promise<SupplierBill> =>
    (await axios.post(ENDPOINTS.SUPPLIER_BILL.REVERSE(id))).data,
  releaseBlock: async (id: string, justification: string): Promise<SupplierBill> =>
    (await axios.post(ENDPOINTS.SUPPLIER_BILL.RELEASE_BLOCK(id), { justification })).data,
  edit: async (id: string, dto: BillEditDTO): Promise<SupplierBill> =>
    (await axios.put(ENDPOINTS.SUPPLIER_BILL.EDIT(id), dto)).data,
  editHistory: async (id: string): Promise<SupplierBillEdit[]> =>
    (await axios.get(ENDPOINTS.SUPPLIER_BILL.EDIT_HISTORY(id))).data,
};
